import { CurrencyCounterRenderer } from '@loyalty/editor-components';
import { Editor } from 'grapesjs';
import { faUsdCircle } from '@fortawesome/pro-solid-svg-icons/faUsdCircle';
import { CurrencyCounterWidgetTraits } from './CurrencyCounterWidgetTraits';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';

const CLASSNAME = 'qlfeditor-currency-counter';

export const currencyCounterComponentDefinition: EditorComponentDefinition = {
  id: 'currency-counter',
  icon: faUsdCircle,
  category: 'Gamification',
  getLabel: ({ t }) => t('editor.component.currency-counter'),
  traits: {
    form: CurrencyCounterWidgetTraits,
  },
  component: CurrencyCounterGrapesComponent,
  copyPasteHelper: (element, context) => {
    element.attributes.currencyId = context.defaultCurrencyId;
  },
};

export function CurrencyCounterGrapesComponent(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;
  const currencies = context.currencies;

  editor.DomComponents.addType(currencyCounterComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        droppable: false,
        draggable: '[data-gjs-type=column]',
        attributes: {
          showTotal: true,
          showCurrencyPicture: true,
          showCurrencyName: true,
          showExpiration: false,
          currencyId: `${currencies[0]?.id}`,
        },
        traits: [],
      },
      initToolbar: Toolbar,
      init() {
        this.on('change:attributes', this.refresh);
      },
      refresh() {
        setTimeout(() => this.view?.onRender());
      },
      toHTML(): string {
        return CurrencyCounterRenderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
